module.exports = __webpack_public_path__ + "img/category-brand.0712f8b0.png";